import { render, staticRenderFns } from "./formula.vue?vue&type=template&id=bee6336e&scoped=true"
import script from "./formula.vue?vue&type=script&lang=js"
export * from "./formula.vue?vue&type=script&lang=js"
import style0 from "./formula.vue?vue&type=style&index=0&id=bee6336e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee6336e",
  null
  
)

export default component.exports